<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>系统管理</el-breadcrumb-item>
			<el-breadcrumb-item>角色管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!--搜索部分-->
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="角色搜索">
					<el-input v-model="queryKey" placeholder="按角色名称搜索">
						<i slot="prefix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="info" @click="query">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="create">创建角色</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table :data="tableData" v-loading="tableLoading" width="100%">
			<el-table-column type="index" label="序号" width="60px"></el-table-column>
			<el-table-column label="角色名称" prop="name"></el-table-column>
			<el-table-column label="用户数量" prop="user_count" width="120px"></el-table-column>
			<el-table-column label="编辑" width="200px">
				<template slot-scope="scope">
					<el-button @click="handleSetRights(scope.row)" type="text" size="small">配置权限</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.row)">
						<el-button slot="reference" type="text" size="small">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="sizes, prev, pager, next" :total="0"> </el-pagination>

		<!--创建角色-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
			<el-form :model="form" ref="roleForm" :rules="rules">
				<el-form-item label="角色名称" prop="name" :label-width="formLabelWidth">
					<el-input v-model="form.name" autocomplete="off" placeholder="请输入角色名称"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">确 定</el-button>
			</div>
		</el-dialog>

		<el-drawer title="权限配置" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
			<div class="drawer__conten">
				<role-tree class="tree" ref="tree" :selected="selectedRights"></role-tree>
				<div class="drawer__footer">
					<el-button @click="drawer = false">取 消</el-button>
					<el-button type="primary" @click="saveRights" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import userService from '@/service/userService'
	import RoleTree from './RoleTree'
	export default {
		components: {
			RoleTree,
		},
		name: 'roleManage',
		data() {
			return {
				queryKey: '',
				tableData: [],
				tableLoading: false,
				dialogVisible: false,
				dialogTitle: '创建角色',
				formLabelWidth: '120px',
				form: {},
				currentPage: 1,
				pageSize: 10,
				drawer: false,
				loading: false,
				currentRow: {},
				selectedRights: [],
				rules: {
					name: [
						{ required: true, message: '请输入角色名称', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' },
					],
				},
			}
		},
		computed: {},
		methods: {
			/**
			 * 创建角色。
			 */
			create() {
				this.dialogTitle = '创建角色'
				this.dialogVisible = true
				this.form = {}
			},
			/**
			 * 获取所有角色。
			 */
			query() {
				userService
					.getRoles()
					.then(res => {
						this.tableData = res
					})
					.finally(() => {
						this.tableLoading = false
					})
			},
			/**
			 * 保存角色。
			 */
			save() {
				this.$refs.roleForm.validate(valid => {
					if (valid) {
						userService.saveRole(this.form).then(res => {
							this.tableLoading = true
							this.query()
						})
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
			handleSizeChange() {},
			handleCurrentChange() {},
			/**
			 * 编辑角色。
			 */
			handleEdit(row) {
				this.dialogTitle = '编辑角色名称'
				this.form = { ...row }
				this.dialogVisible = true
			},
			/**
			 * 删除角色。
			 */
			handleDelete(row) {
				userService.deleteRole(row._id.$oid)
			},
			/**
			 * 配置权限。
			 */
			handleSetRights(row) {
				this.drawer = true

				console.log(row)

				this.currentRow = row
				if (this.currentRow) {
					this.selectedRights = this.currentRow.functions
				} else {
					this.selectedRights = []
				}

				console.log(this.selectedRights)
			},
			/**
			 * 关闭权限配置。
			 */
			handleClose(done) {
				done()
			},
			/**
			 * 保存权限。
			 */
			saveRights() {
				//获取选中的权限。
				var ids = this.$refs.tree.getCheckedKeys()
				//角色Id。
				var roleId = this.currentRow.id

				this.loading = true
				//保存。
				userService
					.saveRoleRights(roleId, ids)
					.then(res => {
						this.drawer = false
						this.currentRow = null
					})
					.finally(() => {
						this.tableLoading = true
						this.query()
						this.loading = false
					})

				console.log(ids)
			},
		},
		created() {
			this.tableLoading = true
			this.query()
		},
	}
</script>

<style scoped>
	.drawer__conten {
		position: relative;
		height: 100%;
	}

	.drawer__conten .tree {
		overflow: auto;
		position: absolute;
		right: 0;
		left: 0;
		bottom: 80px;
		top: 0;
		border-top: 1px #eee solid;
		border-bottom: 1px #eee solid;
	}

	.drawer__footer {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		padding: 20px;
	}
</style>
